#import "../fragments/broadcast-fragment.graphql"

query GetBroadcast($broadcastId: ID!) {
    broadcast(id: $broadcastId) {
        ...BroadcastFragment
    }
}
